import React from 'react';
import { connect } from 'react-redux';
import { Tabs, Input, Modal, Pagination, Empty } from 'antd';
import Scrollbars from 'react-custom-scrollbars';
import ManuscriptPoolItem from '../components/manuscriptPool/ManuscriptPoolItem';
import PublishInfoModal from './publishInfoModal';
import RelationTaskDetail from "../components/manuscriptPool/RelationTaskDetail";
import RelationSelectTopicDetail from "../components/manuscriptPool/RelationSelectTopicDetail";
import { getPublishData, withdraw, delManuscript } from '../../actions/publishContent';
import * as utils from "../../utils";
import * as actions from "../../actions/originalManuscript";
import "./publishContent.scss";

const tabs = [
    {
        title: '所有内容',
        key: '0'
    },
    {
        title: '已发布',
        key: '2'
    },
    {
        title: '已撤回',
        key: '1',
    }
]

const { TabPane } = Tabs;
const { Search } = Input;
const { confirm } = Modal;
const { TextArea } = Input;
class PublishContent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: '0',
            mediaCode: this.props.match.params.mediaCode,
            current: 1,
            pageSize: 10,
            list: [],
            total: 0,
            publishInfo: {},
            visible: false,
        }
    }

    componentDidMount() {
        this.getList();
    }

    getList = (queryStr = '') => {
        let mediaCode = this.props.match.params.mediaCode;
        let params = { page: this.state.current, pageSize: this.state.pageSize, mediaCode, status: this.state.activeKey, queryStr }
        getPublishData(params, (res) => {
            this.setState({
                list: res.data,
                total: res.count
            })

        })
    }

    changePage = (page) => {
        this.setState({
            current: page
        }, () => {
            this.getList();
        })
    }

    changeActiveKey = (activeKey) => {
        this.setState({
            activeKey,
            current:1
        }, () => {
            console.log(this.state.activeKey)
            this.getList();
        })
    }

    renderBtn = (item) => {
        if (item.statusName === '发布') {
            return (
                <div className="buttons">
                    <span onClick={() => this.publishInfoModal.show(item)} >发布信息</span>
                    <span onClick={() => { this.revert(item) }}>撤回</span>
                </div>
            )
        } else {
            return (
                <div className="buttons">
                    <span onClick={() => this.del(item)}>彻底删除</span>
                    <span onClick={() => { let publishInfo = { storyId: item.id, publishUrl: item.publishUrl ? item.publishUrl : '', remark: item.remark ? item.remark : '' }; this.setState({ visible: true, publishInfo }) }}>重新发布</span>
                </div>
            )
        }
    }

    //撤回
    revert = (item) => {
        //调用撤回接口
        confirm({
            title: '确定撤回此稿件?',
            onOk: () => {
                //调用撤回接口
                withdraw({ id: item.id }, (res) => {
                    this.setState({
                        current: 1,
                    }, () => {
                        this.getList();
                    })
                })
            },
            onCancel: () => {
                //cancel
            },
        });
    }

    //删除
    del = (item) => {
        //调用删除接口
        confirm({
            title: '确定删除此稿件?',
            onOk: () => {
                //调用删除接口
                delManuscript({ id: item.id }, (res) => {
                    this.setState({
                        current: 1,
                    }, () => {
                        this.getList();
                    })
                })
            },
            onCancel: () => {
                //cancel
            },
        });
    }

    //重新发布
    handlePublish = () => {
        //调用删除接口
        confirm({
            title: '确定重新发布此稿件?',
            onOk: () => {
                let mediaCode = this.props.match.params.mediaCode;
                actions.publish({mediaCode: mediaCode, ...this.state.publishInfo}, (res) => {
                   
                    this.setState({
                        visible: false,
                        current: 1
                    }, () => {
                        this.getList();
                    });
                })
            },
            onCancel: () => {
                //cancel
            },
        });
    }

    changePublishInfo = (e, type) => {
        let publishInfo = this.state.publishInfo;
        publishInfo[type] = e.target.value;
        this.setState({
            publishInfo
        })
    }

    itemTitleClick(item) {
        window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank')
    }

    render() {
        const { activeKey, list } = this.state;
        let height = window.innerHeight - 70;
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        return (
            <>
                <div className="publish-content" style={{ height }}>
                    <div className="publish-content-top">
                        <div className="publish-content-top-title" style={{ color: newSecondSelectColor }}>已发布内容</div>
                        <div className="publish-content-top-tabs">
                            <Tabs className="publishcontent" activeKey={activeKey} onChange={this.changeActiveKey}>
                                {
                                    tabs.map((item, index) => (
                                        <TabPane tab={item.title} key={item.key}></TabPane>
                                    ))
                                }
                            </Tabs>
                            <style>
                                {`
                                .publishcontent  .ant-tabs-bar .ant-tabs-tab-active {
                                color:${newSecondSelectColor}!important ;
                                font-weight:bold !important;
                                font-size:16px !important;
                                    }
                                    .publishcontent  .ant-tabs-nav-container  {
                                font-size:16px !important;
                                    }
                                .publishcontent .ant-tabs-ink-bar{
                                    background-color:  ${newSecondSelectColor} !important;
                                    }
                                .publishcontent  .ant-tabs-nav .ant-tabs-tab {
                                color: #6c748b;
                                font-weight:bold !important;
                                }
                                .publishcontent  .ant-tabs-nav .ant-tabs-tab:hover {
                                    color: ${newSecondSelectColor} !important;
                                }
                             `}
                            </style>
                        </div>
                    </div>
                    <div className="publish-content-search">
                        <Search
                            placeholder="请输入"
                            onSearch={value => {
                                this.state.current=1;
                                this.getList(value)}}
                            style={{ width: 200 }}
                        />


                    </div>
                    <div className="publish-content-wrap" style={{ height: list.length === 0 ? 'calc( 100% - 125px )' : 'calc( 100% - 185px )' }}>
                        {
                            list.length === 0 ? <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}><Empty /></div> :
                                <Scrollbars>
                                    {
                                        list.map((item, index) => {
                                            let submitStatusName = '';
                                            if (item.statusName === '发布') {
                                                submitStatusName = '已发布';
                                            } else {
                                                submitStatusName = '已撤回';
                                            }
                                            let sex = item.submitUser && item.submitUser.sex ? item.submitUser.sex : 1;
                                            if (this.props.currentUser)
                                                sex = this.props.currentUser.sex;
                                            let photo = "images/header_boys.png";
                                            /* if (this.props.currentUser && this.props.currentUser.photoUrl && this.props.currentUser.photoUrl.length > 0) {
                                                 photo = this.props.currentUser.photoUrl
                                             } else {*/
                                            if (sex === 2) {
                                                photo = "/cm-sites/images/header_girls.png";
                                            }
                                            return (
                                                <ManuscriptPoolItem
                                                    key={index}
                                                    newSecondSelectColor={newSecondSelectColor}
                                                    title={item.title}
                                                    submitStatusName={submitStatusName}
                                                    submitTime={''}
                                                    createTime={item.submitDate && item.submitDate.time ? utils.formatDate(item.submitDate.time) : ''}
                                                    changeTime={item.changeDate && item.changeDate.time ? utils.formatDate(item.changeDate.time) : ''}
                                                    mark={item.summary}
                                                    task1={item.interview && item.interview.id ? item.interview.title : ''}
                                                    task2={item.topicSelection && item.topicSelection.id ? item.topicSelection.tsName : ''}
                                                    name={item.submitUser ? item.submitUser.name : ''}
                                                    titlePic={item.titlePic}
                                                    userPic={item.submitUser && item.submitUser.photoUrl ? item.submitUser.photoUrl : photo}
                                                    titleClick={() => {
                                                        this.itemTitleClick(item)
                                                    }}
                                                    task1Click={() => {
                                                        if (item.interview && item.interview.id) {
                                                            this.RelationTaskDetail.taskDetailShow(item.interview.id);
                                                        }
                                                    }}
                                                    task2Click={() => {
                                                        if (item.topicSelection && item.topicSelection.id) {
                                                            this.RelationSelectTopicDetail.selectTopicDetailDetailShow(item.topicSelection.id);
                                                        }
                                                    }}
                                                    btn={this.renderBtn(item)}
                                                />
                                            )
                                        })
                                    }
                                </Scrollbars>
                        }
                    </div>
                    {
                        list.length === 0 ? '' :
                            <div className="publish-content-bottom">
                                <Pagination
                                    current={this.state.current}
                                    pageSize={this.state.pageSize}
                                    total={this.state.total}
                                    onChange={this.changePage}
                                />
                            </div>
                    }
                </div>
                <PublishInfoModal ref={(publishInfoModal) => this.publishInfoModal = publishInfoModal} />
                <Modal
                    title="确认发布"
                    visible={this.state.visible}
                    onOk={this.handlePublish}
                    onCancel={() => { this.setState({ visible: false }) }}
                    destroyOnClose
                >
                    <div>
                        <div style={{ display: 'flex', paddingBottom: 20 }}>
                            <span style={{ width: 90, textAlign: 'right' }}>发布链接：</span>
                            <Input value={this.state.publishInfo.publishUrl} onChange={(e) => { this.changePublishInfo(e, 'publishUrl') }} />
                        </div>
                        <div style={{ display: 'flex' }}>
                            <span style={{ width: 90, textAlign: 'right' }}>备注：</span>
                            <TextArea value={this.state.publishInfo.remark} rows={4} onChange={(e) => { this.changePublishInfo(e, 'remark') }} />
                        </div>
                    </div>
                </Modal>
                <RelationTaskDetail ref={RelationTaskDetail => this.RelationTaskDetail = RelationTaskDetail} />
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => this.RelationSelectTopicDetail = RelationSelectTopicDetail} />
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        config: state.systemReducer.config
    }
}


export default connect(mapStateToProps)(PublishContent)